import React, { useEffect, useState } from 'react';
import { answerType } from '../../constants/enums';
import { Radio, Space } from 'antd';
import './PrefilterTest.scss';
import Input from '../Input';
import Select from '../Select/Select';
import StyledInput from '../NewStyleInput/StyledInput';
import MapContainer from '../Map/MapContainer';

export default function Test({ question, onSubmit, isLast, isFirst, submission, t }) {
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState();
  const [locationLabel, setLocationLabel] = useState('');
  const [inputDetailedValue, setInputDetailedValue] = useState();
  const [mapMarker, setMapMarker] = useState(null);

  const errorInputValue =
    (question.answerType === answerType.WRITE &&
      question?.validatorRegex &&
      !new RegExp(question?.validatorRegex)?.test(inputValue)) ||
    (question.answerType === answerType.WRITE && question?.maxChar > 0 && inputValue?.length > question?.maxChar) ||
    (question.answerType === answerType.TEXT && !new RegExp('^\\d*$')?.test(inputValue));
  const disableButton =
    ([answerType.RADIO, answerType.SELECT].includes(question?.answerType) && !selectedOptionId) ||
    ([answerType.TEXT, answerType.WRITE].includes(question?.answerType) &&
      (!inputValue || inputValue?.trim() !== '') &&
      errorInputValue) ||
    (question.answerType === answerType.SELECT && selectedOption?.hasSubQuestion && !inputDetailedValue) ||
    (question.answerType === answerType.LOCATIONS && !inputValue);

  const handleSubmit = next => {
    const data = { id: question?._id, type: question.answerType, response: undefined };
    if ([answerType.RADIO, answerType.SELECT].includes(question?.answerType) && selectedOptionId) {
      data.response = selectedOptionId;
    } else if ([answerType.TEXT, answerType.WRITE].includes(question?.answerType)) {
      data.response = inputValue;
    } else if (question.answerType === answerType.LOCATIONS) {
      data.response = inputValue;
    }
    if (question.answerType === answerType.SELECT) data.subResponse = inputDetailedValue;
    clearData();
    onSubmit(data, next);
  };

  const selectParentOption = optionId => {
    const option = question.options.find(option => option.id === optionId);
    setSelectedOption(option);
    setSelectedOptionId(optionId);
  };

  useEffect(() => {
    if (submission && submission?._id === question?.id) {
      if ([answerType.RADIO, answerType.SELECT].includes(question.answerType)) {
        selectParentOption(submission.response);
        setInputDetailedValue(submission?.subResponse);
      } else if ([answerType.TEXT, answerType.WRITE].includes(question.answerType)) {
        setInputValue(submission.response);
      } else if (answerType.LOCATIONS === question.answerType && submission.response) {
        const [lat, lng, label] = submission?.response?.split(',');
        setInputValue(submission.response);
        setLocationLabel(label);
        setMapMarker({
          id: submission.id,
          position: {
            lat: Number(lat),
            lng: Number(lng),
          },
          label: { text: label, className: 'map-marker-label' },
        });
      }
    }
  }, [question, submission]);

  const clearData = () => {
    setSelectedOptionId(null);
    setSelectedOption(null);
    setInputValue('');
    setInputDetailedValue('');
    setLocationLabel('');
    setMapMarker(null);
  };

  return (
    <div className='p-3'>
      <h3 className='p-4 mt-2 mb-5 border-1 border-alkemy-blue rounded rbc-label'>{question.text}</h3>

      {question.answerType === answerType.RADIO && (
        <div>
          <Radio.Group onChange={e => setSelectedOptionId(e.target.value)} value={selectedOptionId}>
            <Space direction='vertical'>
              {question.options.map((option, index) => (
                <Radio
                  key={option.id}
                  value={option.id}
                  className='ant-radio-wrapper d-flex align-items-center py-2 px-3 bg-gray rounded mb-2 w-full border-1 border-gray-300'>
                  <span className='mr-4 font-bold'>{String.fromCharCode(65 + index)}.</span>
                  {option.text}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        </div>
      )}

      {question.answerType === answerType.TEXT && (
        <div>
          <Input
            className='outline-none text-xs border-1 font-semibold shadow-sm w-full rounded-lg py-1 bg-transparent px-2 truncate border-gray-300 rbc-label'
            placeholder={t('PREFILTER_TEXT_INPUT_PLACEHOLDER')}
            type='number'
            onChange={e => setInputValue(e.target.value.replace(/[^0-9]/g, ''))}
            defaultValue={inputValue?.replace(/[^0-9]/g, '')}
            error={errorInputValue ? { message: t('PREFILTER_TEST_VALID_RESPONSE_NUMBER') } : {}}
          />
        </div>
      )}

      {question.answerType === answerType.WRITE && (
        <div>
          <Input
            className='outline-none text-xs border-1 font-semibold shadow-sm w-full rounded-lg py-1 bg-transparent px-2 truncate border-gray-300 rbc-label'
            placeholder={t('PREFILTER_TEXT_INPUT_PLACEHOLDER')}
            type={question?.validatorType === 'NUMBER' ? 'number' : 'text'}
            onChange={e => setInputValue(e.target.value)}
            maxLength={question?.maxChar > 0 ? question?.maxChar : 150}
            defaultValue={inputValue}
            error={
              errorInputValue
                ? {
                    message: t('PREFILTER_TEST_VALID_RESPONSE_TYPE'.replace('TYPE', question.validatorType))?.replace(
                      '{maxChar}',
                      question?.maxChar || 150,
                    ),
                  }
                : {}
            }
          />
          <div className='w-full flex justify-end'>
            <span className='rbc-label text-xs text-gray-500'>
              {inputValue?.length}/{question?.maxChar > 0 ? question?.maxChar : 150}
            </span>
          </div>
        </div>
      )}

      {question.answerType === answerType.SELECT && (
        <div>
          <div className='border-1 rounded-lg border-gray-300'>
            <Select
              className='styled-select bg-transparent appearance-none bg-[calc(100%)_center] bg-no-repeat truncate text-xs py-1 pr-2 w-[calc(100%_-_1rem)] flex-grow font-semibold rbc-label'
              title={t('PREFILTER_SELECT_TEST_TITLE')}
              marginSelect='ml-1 mt-2'
              required
              name={'selectedOption'}
              onChange={e => selectParentOption(e.target.value)}
              defaultValue={selectedOptionId}
              options={question.options.map(option => ({
                id: option.id,
                name: option.text,
              }))}
            />
          </div>
          {selectedOption?.hasSubQuestion && (
            <>
              <StyledInput
                key='subResponse'
                className='outline-none text-xs mt-2 w-full rounded-lg py-1 bg-transparent px-2 truncate border-gray-300 rbc-label'
                title={selectedOption.subQuestionText}
                onChange={e => {
                  setInputDetailedValue(e.target.value);
                }}
                required
                type='text'
                value={inputDetailedValue}
                name='subResponse'
                error={false}
              />
            </>
          )}
        </div>
      )}
      {question.answerType === answerType.LOCATIONS && (
        <div>
          <h4 className='p-1 border-1 mt-2 mb-5 rounded rbc-label'>
            {locationLabel || t('PREFILTER_TEST_LOCATION_SET_POINTER')}
          </h4>
          <MapContainer
            markers={mapMarker}
            onChangeCoordinates={e => {
              setInputValue(`${e?.position?.lat},${e?.position?.lng},${e?.label?.text}`);
              setLocationLabel(e?.label?.text);
            }}
          />
        </div>
      )}

      <div className='px-3'>
        {!isFirst && (
          <button
            onClick={() => handleSubmit(-1)}
            className='w-fit px-5 mr-5 py-1 m-auto mt-5 bg-maya-blue font-bold rounded-2xl text-white hover:cursor-pointer
          disabled:bg-grey disabled:cursor-not-allowed'>
            {t('BACK_PREFILTER_QUESTION')}
          </button>
        )}
        <button
          className='w-fit px-5 py-1 ml-5 m-auto mt-5 bg-maya-blue font-bold rounded-2xl text-white hover:cursor-pointer disabled:bg-grey disabled:cursor-not-allowed'
          onClick={() => (isLast ? handleSubmit(0) : handleSubmit(1))}
          disabled={disableButton}>
          {isLast ? t('SUBMIT_PREFILTER_QUESTION') : t('NEXT_PREFILTER_QUESTION')}
        </button>
      </div>
    </div>
  );
}
